import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import { StationMapper } from '../../mappers/table/common/station-mapper.service';
import { StationsRepo } from '../../repositories/station-repo';
import { StationsActions } from './stations.actions';

export class StationsEffect {
  private readonly actions$ = inject(Actions);
  private readonly apiService = inject(StationsRepo);
  private readonly stationMapper = inject(StationMapper);

  search$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(StationsActions.search),
      mergeMap((param) => {
        return this.apiService
          .getStationsListCustom(param.filter.offset, param.filter.limit)
          .pipe(
            map((response) =>
              StationsActions.fetchSuccess({ response: response.list || [] })
            ),
            catchError((error) =>
              of(StationsActions.fetchFailure({ message: error?.toString() }))
            )
          );
      })
    );
  });
}
